<template>
	<EventLayout :event="event" :subtitle="trans('events.packs.title')">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="showModal('create-pack-modal')">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</PrimaryButton>
		</template>
		<Modal id="create-pack-modal" overflow>
			<template #title>{{ trans('events.packs.create') }}</template>
			<div class="flex items-end gap-3">
				<LabeledObject required full>
					<template #label>{{ trans('events.activities.types.title') }}</template>
					<select v-model="form.type">
						<option v-for="type in ActivityScope" :value="type">{{ trans(`events.activities.types.${type}`) }}</option>
					</select>
				</LabeledObject>
				<Switch v-model.number="form.active" :label="trans('general.enabled')"/>
				<Switch v-model.number="form.mandatory" :label="trans('events.packs.mandatory')"/>
			</div>
			<LabeledObject required full>
				<template #label>{{ trans('events.packs.name') }}</template>
				<input v-model="form.name" type="text">
			</LabeledObject>
			<template #footer>
				<PrimaryButton :color="Color.Green" @click="create">
					<i class="fa-solid fa-check mr-2"/>
					{{ trans('general.confirm') }}
				</PrimaryButton>
			</template>
		</Modal>
		<slot/>
	</EventLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, ref, type Ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import Modal from '@/Components/UI/Modals/Modal.vue'
import {type Pack} from '@/Types/Events/Packs/Pack'
import EventLayout from '@/Layouts/EventLayout.vue'
import Switch from '@/Components/UI/Switches/Switch.vue'
import {type InertiaForm, useForm} from '@inertiajs/vue3'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showModal, showSuccess, showValidationErrors} from '@/Helpers/general'
import {ActivityScope} from '@/Types/Enums/ActivityScope'

const props = defineProps<{
	event:Event,
}>()

const event:Ref<Event> = ref(props.event)
const inserting:Ref<boolean> = ref(false)
const form:InertiaForm<Pack> = useForm<Pack>({
	name: '',
	type: ActivityScope.Dissertation,
	active: false,
	mandatory: false,
	event_id: props.event.id,
} as Pack)

function create():void{
	if(!inserting.value){
		inserting.value = true
		showInfo(trans('general.inserting'))
		form.post(route('events.packs.store', event.value.id), {
			onSuccess: () => {
				showSuccess(trans('general.inserted'))
			},
			onError: showValidationErrors,
			onFinish: () => {
				inserting.value = false
			},
		})
	}
}
</script>